import { useEffect, useState } from 'react'
import { Button, Card, Col, Container, Form, FormLabel, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import KLayerNavigation from '../components/KLayerNavigation'
import { hideKAlert, isUserLoggedIn, setCompanyInfo, showKAlert } from '../helpers'
import { t } from '../locale'
import { Company, CompanyInfo } from '../react-app-env'
import v from '../validators'

function Edit() {
  const navigate = useNavigate()

  const [company, setCompany] = useState({} as Company)
  const [companyName, setCompanyName] = useState('')
  const [street, setStreet] = useState('')
  const [city, setCity] = useState('')
  const [postalCode, setPostalCode] = useState('')
  const [vat, setVat] = useState('')

  const [isCompanyNameValid, setIsCompanyNameValid] = useState(true)

  function update(company: Company) {
    fetch(`${process.env.REACT_APP_API_URL}/company-admin`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(company),
    })
      .then(r => r.json())
      .then(r => {
        if (r.ok) {
          const companyInfo: CompanyInfo = {
            name: companyName,
          }
          setCompanyInfo(companyInfo)
          navigate('/company')
          showKAlert('success', 'success')
        }
      })
  }

  function handleCompanyName(e: any) {
    setCompanyName(e.target.value.trimStart())
    setIsCompanyNameValid(v.companyName(companyName))
  }

  function handleStreet(e: any) {
    setStreet(e.target.value)
  }

  function handleCity(e: any) {
    setCity(e.target.value)
  }

  function handlePostalCode(e: any) {
    setPostalCode(e.target.value)
  }

  function handleVat(e: any) {
    setVat(e.target.value)
  }

  function handleSubmit(e: any) {
    e.preventDefault()

    setIsCompanyNameValid(v.companyName(companyName))

    if (v.companyName(companyName)) {
      const updatedCompany: Company = {
        ...company,
        name: companyName,
        street: street,
        city: city,
        postalCode: postalCode,
        vat: vat,
      }

      update(updatedCompany)
    }
  }

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/company-admin`)
      .then(r => r.json())
      .then(r => {
        if (!!r.company) {
          const _company = r.company
          setCompany(_company)
          setCompanyName(_company.name)
          setStreet(_company.street || '')
          setCity(_company.city || '')
          setPostalCode(_company.postalCode || '')
          setVat(_company.vat || '')
        }
      })
  }, [])

  return (
    <>
      <Container>
        <Row>
          <div className='sidebar col-md-3 col-lg-2 p-0'>
            <KLayerNavigation logged={isUserLoggedIn()} />
          </div>
          <main className='col-md-9 ms-sm-auto col-lg-10 px-md-4'>
            <h2> {t('Edit company data')}</h2>
            <hr className='my-3' />

            <Card.Body className='px-3'>
              <Form onSubmit={handleSubmit} className='needs-validation' noValidate>
                {/* Row 1: Company Name, Street, City */}
                <Row className='g-2'>
                  <Col xs={12} md={4}>
                    <div className='form-floating mb-2'>
                      <Form.Control
                        id='companyName'
                        type='text'
                        placeholder={t('Company name')}
                        value={companyName}
                        onChange={handleCompanyName}
                        isInvalid={!isCompanyNameValid}
                        autoComplete='off'
                        required
                      />
                      <FormLabel htmlFor='companyName' className='small'>
                        {t('Company name')}
                      </FormLabel>
                    </div>
                  </Col>
                </Row>
                <hr className='my-3' />
                <h5> {t('Address')}</h5>

                <Row className='g-2'>
                  <Col xs={12} md={4}>
                    <div className='form-floating mb-2'>
                      <Form.Control
                        id='city'
                        type='text'
                        placeholder={t('City')}
                        value={city}
                        onChange={handleCity}
                        autoComplete='off'
                      />
                      <FormLabel htmlFor='city' className='small'>
                        {t('City')}
                      </FormLabel>
                    </div>
                  </Col>
                  <Col xs={12} md={4}>
                    <div className='form-floating mb-2'>
                      <Form.Control
                        id='street'
                        type='text'
                        placeholder={t('Street')}
                        value={street}
                        onChange={handleStreet}
                        autoComplete='off'
                      />
                      <FormLabel htmlFor='street' className='small'>
                        {t('Street')}
                      </FormLabel>
                    </div>
                  </Col>
                  <Col xs={12} md={4}>
                    <div className='form-floating mb-2'>
                      <Form.Control
                        id='postalCode'
                        type='text'
                        placeholder={t('Postal Code')}
                        value={postalCode}
                        onChange={handlePostalCode}
                        autoComplete='off'
                      />
                      <FormLabel htmlFor='postalCode' className='small'>
                        {t('Postal Code')}
                      </FormLabel>
                    </div>
                  </Col>
                </Row>

                {/* Row 2: Postal Code, VAT */}
                <Row className='g-2'>
                  <Col xs={12} md={4}>
                    <div className='form-floating mb-2'>
                      <Form.Control
                        id='vat'
                        type='text'
                        placeholder={t('VAT')}
                        value={vat}
                        onChange={handleVat}
                        autoComplete='off'
                      />
                      <FormLabel htmlFor='vat' className='small'>
                        {t('VAT')}
                      </FormLabel>
                    </div>
                  </Col>
                </Row>

                {/* Action buttons */}
                <hr className='my-4' />

                <Row className='gx-2'>
                  <Col xs={6} className='text-start'>
                    <Button
                      onClick={() => {
                        hideKAlert()
                        navigate('/company')
                      }}
                      className='btn-warning text-white'
                    >
                      « {t('Cancel')}
                    </Button>
                  </Col>

                  <Col xs={6} className='text-end'>
                    <Button type='submit' className='btn-success text-white'>
                      {t('Save')} »
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </main>
        </Row>
      </Container>
    </>
  )
}

export default Edit
